// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___PO0ZB","visible-sm":"visible-sm___1lXtl","visible-md":"visible-md___3rXb1","visible-lg":"visible-lg___aJ8NE","row":"row___2o--M","hidden-xs":"hidden-xs___2b1KX","hidden-sm":"hidden-sm___18iiI","hidden-md":"hidden-md___CTp1T","hidden-lg":"hidden-lg___YtMM8","page":"page___3UjFp page___2ZhHk","main":"main___2puPb container___mp8vb","notfound":"notfound___KwwmE container-inner___1ne89"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/IndexFunds/IndexFunds.css
// module id = 871
// module chunks = 0